/**
 * SFDC (Salesforce) deep-link helpers. `Opportunity` is the only entity
 * currently linked from the IVT views; extend this file if / when Account or
 * other record types need one too. The 18-char id is the canonical SFDC opp
 * id already carried on our data types (PipelineOpp.oppId /
 * PipelineListItem.opptyId).
 */

const SFDC_OPP_URL = 'https://aws-crm.lightning.force.com/lightning/r/Opportunity/';

export function oppSfdcUrl(oppId: string): string {
  return `${SFDC_OPP_URL}${oppId}/view`;
}
